import store from '@/store';
import Validator from './validator'
import { mpx } from '@didi/es-mpx-creator'
import { is, goTo, build, launchApp, bridge } from '@didi/webx-js'


/**
 *
 * @param {string} data - 要脱敏的数据
 * @param {number} star - 开始索引
 * @param {number} end - 截止索引
 * @returns { string } - 脱敏后的数据
 */
 export function desensitize(data, star = 0, end = data.length) {
  if (end < 0) {
    end = end + data.length;
  }
  const len = Math.abs(end - star);
  return data.substring(0, star) + '*'.repeat(len) + data.substring(end);
}

/**
 *
 * @param {string} data - 要脱敏的手机号
 * @param {number} contact_phone - 开始索引
 * @returns { string } - 脱敏后的数据
 */

 export function desensitizePhone(contact_phone) {
  if (contact_phone && contact_phone.length > 7) {
    return desensitize(contact_phone, 3, -4)
  } else if (contact_phone && contact_phone.length <= 7) {
    return contact_phone;
  }
}

export const getWXAppid = () => {
  const reg = /miniProgram\/[\w]+/ig; // 官方没有公布appid的格式，目前是小写字母+数字
  const miniAppid = reg.exec(window.navigator.userAgent);
  return miniAppid ? miniAppid[0]?.split('/')[1] : null;
};


/**
 * @desc 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
 export function debounce(func, wait=300, immediate=false) {
  let timeout;

  return function () {
    let context = this;
    let args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait)
      if (callNow) func.apply(context, args)
    }
    else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
  }
}


export function desensitizeCardId(val) {
  if(val.length < 10) {
    return desensitize(val, 2, -2);
  }
  if (val.length < 15) {
    return desensitize(val, 4, -2);
  }
  return desensitize(val, 6, -2);
}

export function isMissing(data, need_card, config) {
  // console.log("config",config)
  let configKey = Object.keys(config || {})
  let isCardExpiredShow = config['expire_date'] && data.card_list && hasRequired(
    config['expire_date'].requiredcCrdTypes || [],
    [data.card_list[0]],
    config['expire_date'].isRequired,
    need_card
  )
  //  config['expire_date'].isShow

  //1、证件:需要证件但是没有证件号或者除身份证以为的证件，没有证件有效期
  //2、国际业务中: 英文姓名、手机号、出生日期、性别、国际必填
  //3、国内业务中: 中文名、手机号必填
  let isCardMissing = need_card === '1' && (
    data.card_list?.length == 0 || (
      data.card_list?.length > 0 && (
        !data.card_list[0].id_no || (
          data.card_list[0].card_type !== '1' && data.card_list[0].expire_date === '' && isCardExpiredShow
          )
        )
      )
  )
  let isOtherMissing = false
  configKey.map( item => {
    // console.log(item,isOtherMissing);
    let card_list = data?.card_list?.[0]?[data.card_list[0]] : []
    let isRequired = hasRequired(config[item]?.requiredcCrdTypes || [], card_list, config[item]?.isRequired, need_card == '1')
    if(config[item] && isRequired && (data[item]==='' || data[item]==='0') && item!=='nationlity'){
      isOtherMissing = true
      //如果是不需要证件的时候,名字必填，不计入，后面另外判断
      if(need_card === '0' && ['passenger_name','english_surname','english_name'].includes(item) !== -1){
        isOtherMissing = false
      }
    }
    if(config[item] && item==='nationlity' && data.country_code===''&& isRequired){
      isOtherMissing = true
    }
    // console.log(item,isOtherMissing);
  })
  //如果是不需要证件的时候,并且中文名、英文姓名都没有的时候为true
  if(need_card === '0' && !data.passenger_name && (!data.english_surname || !data.english_name)){
    isOtherMissing = true
  }
  // console.log(isCardMissing,isOtherMissing)
  return isCardMissing || isOtherMissing
}

export function isDisableSelect(data, listSelected, maxContact, need_card,config) {

  const phoneIndex = listSelected.findIndex(function(item) {
    return item.contact_phone == data.contact_phone
  });

  let hasAllData = isMissing(data,need_card,config)

  // 需要证件，但是没有证件号 || 超过最大可选人数 || 已离职
  return hasAllData
  || (listSelected.length === maxContact && phoneIndex === -1)
  || data.status == '4'
}

export function checkRequire(cardTypes , selectedCardList) {
  let required = false
  let arrList = [...selectedCardList]
  arrList.forEach((item) => {
    if (item && cardTypes.includes('' + item.code)) {
      required = true
      return
    }
  })
  return required
}

export function hasRequired(cardTypes, selectedCardList, isRequired, isNeedCard) {
  let cardList = []
  if(isNeedCard){
    cardList = selectedCardList
  }
  return checkRequire(cardTypes,cardList) || isRequired
}

// const CHN_NAME_REG = '^[a-zA-Z0-9_\u4e00-\u9fa5 /]+$'
const ENG_NAME_REG = '^[a-zA-Z0-9_ ]+$'

// 姓名的检验
export function checkName(passenger_name){
  var validator = new Validator()
  validator.cbAdd(passenger_name, function (str, msg) {
    var REG = /^[.·a-zA-Z0-9_\u4e00-\u9fa5 /\\]+$/
    if (!REG.test(str || '' )) {
      return msg;
    }
    },'可输入格式汉字、字母、数字、下划线、斜杠、空格、点，姓名长度不超过30个字符')
  validator.cbAdd(passenger_name, function (str, msg) {
        let len = str.length
        if (len > 50) {
          return msg
        }
      }, '姓名长度不可超过50个字符，若过长请用缩写')
  return validator.start()
}

 // 证件
export function permitValidateConf(item = {}) {
  const { code } = item
  switch (code) {
    case '1':
      // 中国居民身份证
      return '^(\\d{6})(\\d{4})(\\d{2})(\\d{2})(\\d{3})([0-9]|X|x)$'
    case 'B':
      // 护照
      return '^\\w{6,}$'
    case 'C':
    case 'G':
    case '6':
      // C 港澳居民来往内地通行证 G 台湾居民来往大陆通行证
      return '^\\w{5,}$'
    case '2':
    case 'H':
      // 2 港澳台居民居住证 H 外国人永久居留证
      return '^\\w{11,}$'
    default:
      break
  }
}

 // 手机号
export function phoneValidateConf(item = {}) {
  const { type } = item
  switch (type) {
    case 1:
      // 中国
      return '^1.{10,10}$';
    case 2:
    case 3:
    case 4:
      // 中国香港 澳门 台湾
      return '^[0-9_]{7,}$';
    default:
      break;
  }
}


// 英文姓名的检验
// export function checkEnglishName(passenger_name){
//   var validator = new Validator()
//   validator.cbAdd(passenger_name, ENG_NAME_REG, '只支持字母、数字、下划线、斜杠、空格')
//   return validator.start()
// }

// // 英文姓名的检验
// export function checkEnglishNameLength(passenger_name){
//   var validator = new Validator()
//   validator.cbAdd(passenger_name, function (str, msg) {
//         let len = str.length
//         if (len > 26) {
//           return msg
//         }
//       }, '姓与名总长度不可超过26个字符，若过长英文名请用缩写')
//   return validator.start()
// }

// 发送事件
export const sendEvent = (name, params = {}) => {
  if (!name) return
  const panel = new Event(name)
  panel.data = params
  window.dispatchEvent(panel)
}

// 监听事件
export const watchEvent = (name, cb, precb) => {
  precb && window.removeEventListener(name, precb);
  window.addEventListener(name, cb);
}


// 跳打车页
export const jumpToDachePage = () => {
  // 小程序打车页路径
  const jumpToMini = () => {
    goTo({ path: build('/home/pages/dache') })
  }
  // 端打车页路径
  const jumpToEntrance = () => {
    bridge?.openPage?.({
      target: 'native',
      url: build('OneTravel://dache_anycar/entrance')
    })
  }
  if (is('miniprogram')) {
    // 跳转小程序打车页
    jumpToMini()
  } else if (is('passenger')) {
    // 跳转端打车页
    jumpToEntrance()
  } else {
    // 其他环境拉端
    mpx?.showModal?.({
      title: '跳转提示',
      content: `将前往滴滴出行App`,
      success(res) {
        if (res.confirm) {
          // 拿当前页面 dchn
          const { dchn } = store?.state?.common?.xpsmInfo
          // 拉端
          launchApp({
            env: 'online',
            launchAppDchn: dchn,
            invokePriority: 'app'
          })
            .then(res => console.log('--------拉端成功-----------', res))
            .catch(err => {
              console.log('--------拉端失败-----------', err)
              mpx.showToast({
                icon: 'none',
                title: '拉起滴滴出行App失败, 请到小程序进行操作呀'
              })
            })
        }
      }
    })
  }
}

// 序列化参数
export const serializeParams = params => {
  const serialized = {}
  for(const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = params[key]
      if (typeof value === 'object' && value !== null) {
        serialized[key] = JSON.stringify(value)
      } else {
        serialized[key] = value
      }
    }
  }
  return serialized
}

// Object snake_case => lowerCamelCase
const toCamelCase = str =>  {
  return str.replace(/_([a-z])/g, function (g) { return g[1].toUpperCase() })
}
export const keysToCamelCase = obj => {
  if(Array.isArray(obj)) {
    return obj.map(v => keysToCamelCase(v))
  }else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (ret, key) => ({
        ...ret,
        [toCamelCase(key)]: keysToCamelCase(obj[key])
      }),
      {}
    )
  }
  return obj
}
export function getMiniPath() {
  const pages = getCurrentPages()
  const currentPagePath =
    (pages[pages.length - 1] && pages[pages.length - 1].route) || ''
  return currentPagePath
}

export function getMiniOptions() {
  const pages = getCurrentPages()
  const currentPage = pages[pages.length - 1]
  return currentPage ? currentPage.options : {}
}

export function pageReload() {
  if(__mpx_mode__ === 'web'){
    window.location.reload()
  }else{
    const tempPath = getMiniPath()
    const tempOptions = getMiniOptions()
    goTo({
      path: '/'+tempPath,
      params:{
        ...tempOptions
      },
      extParams: {
      moveType: 1
      },
    })
  }
}

/**
 * 创建并返回一个新的 Intersection Observer 实例。
 * @param {Function} callback - 当元素进入或离开视野时调用的回调函数。
 * @returns {IntersectionObserver} 一个新的 Intersection Observer 实例。
 */
function createObserver(callback, rootOptions) {
  const options = {
      root: null, // 使用浏览器视窗作为根元素
      rootMargin: '0px', // 边界不留空间
      threshold: 1.0, // 元素完全可见时触发回调
      ...rootOptions
  };

  return new IntersectionObserver(callback, options)
}

/**
* 确认元素是否在视野内的工具函数。
* @param {Element} element - 需要检查是否在视野内的 DOM 元素id。
* @param {Function} inViewCallback - 当元素进入视野时调用的函数。
* @param {Function} outOfViewCallback - 当元素离开视野时调用的函数。
*/
export function observeElementInView(element, inViewCallback, outOfViewCallback, options) {
  const ele = document.querySelector(`#${element}`)
  if(!ele) return console.error(`未找到id为${element}的元素`)
  const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
            inViewCallback && inViewCallback(entry.target, observer) // 元素完全进入视野
          } else {
            outOfViewCallback && outOfViewCallback(entry.target, observer) // 元素完全离开视野
          }
      })
  }
  const observer = createObserver(observerCallback, options)
  observer.observe(ele) // 开始观察元素
  return {
      disconnect: () => observer.disconnect()
  }
}
